const video = [
  {
    title: 'AI加值 智慧製造轉型趨勢與市場發展',
    thumbnail: require('assets/images/home/video-thumbnails/1.jpg'),
    src: 'https://www.youtube.com/embed/KrsHE0R11MQ'
  },
  {
    title: 'AI大解析｜5分鐘認識AI思維 + 趨勢 + 應用',
    thumbnail: require('assets/images/home/video-thumbnails/2.jpg'),
    src: 'https://www.youtube.com/embed/qUlD16lJtNE'
  },
  {
    title: '企業主看過來！　AI轉型該牢記的12字箴言',
    thumbnail: require('assets/images/home/video-thumbnails/3.jpg'),
    src: 'https://www.youtube.com/embed/a_tNiQ72XbE'
  },
  {
    title: '智慧排程｜AI如何優化供應鏈？',
    thumbnail: require('assets/images/home/video-thumbnails/4.jpg'),
    src: 'https://www.youtube.com/embed/_n7O5KpUai4'
  },
  {
    title: 'AOI應用｜AI視覺辨識幫你找出成品瑕疵',
    thumbnail: require('assets/images/home/video-thumbnails/5.jpg'),
    src: 'https://www.youtube.com/embed/F4NqWBJB4AI'
  },
  {
    title: ' AI正夯！　這五種職業最搶手',
    thumbnail: require('assets/images/home/video-thumbnails/6.jpg'),
    src: 'https://www.youtube.com/embed/0o9rvdaZ7cQ'
  },
  {
    title: 'AI解決企業痛點　工廠排程再升級',
    thumbnail: require('assets/images/home/video-thumbnails/7.jpg'),
    src: 'https://www.youtube.com/embed/mjlNHiAGVQA'
  },
  {
    title: '自動光學檢測大突破　靠AI解決兩大痛點',
    thumbnail: require('assets/images/home/video-thumbnails/8.jpg'),
    src: 'https://www.youtube.com/embed/4Vc8eyfSt8w'
  },
  {
    title: 'AI+高效運算　三大優勢助攻企業數位升級',
    thumbnail: require('assets/images/home/video-thumbnails/9.jpg'),
    src: 'https://www.youtube.com/embed/joxcfUnYo9s'
  },
]

export default video;